import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('en') ? 'en' : 'es';

  const setLang = (lng) => {
    i18n.changeLanguage(lng);
    try { localStorage.setItem('nazca360_lang', lng); } catch (e) { /* ignore */ }
  };

  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center gap-1 rounded-full border-2 border-amber-300 bg-white/80 backdrop-blur ${compact ? 'p-0.5' : 'p-1'}`}
    >
      <Globe className={`text-amber-700 ml-1.5 ${compact ? 'w-3.5 h-3.5' : 'w-4 h-4'}`} />
      <button
        type="button"
        data-testid="lang-es"
        onClick={() => setLang('es')}
        className={`px-2.5 py-1 rounded-full text-xs font-semibold transition-colors ${
          current === 'es'
            ? 'bg-gradient-to-r from-amber-600 to-orange-600 text-white shadow-sm'
            : 'text-amber-800 hover:bg-amber-50'
        }`}
        aria-pressed={current === 'es'}
      >
        ES
      </button>
      <button
        type="button"
        data-testid="lang-en"
        onClick={() => setLang('en')}
        className={`px-2.5 py-1 rounded-full text-xs font-semibold transition-colors ${
          current === 'en'
            ? 'bg-gradient-to-r from-amber-600 to-orange-600 text-white shadow-sm'
            : 'text-amber-800 hover:bg-amber-50'
        }`}
        aria-pressed={current === 'en'}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
